<script>
import { validationMixin } from 'vuelidate'
import { required, maxLength } from 'vuelidate/lib/validators'
import { rules } from '@/utils/validators'

import UploadImage from '@/components/UploadImage'
import GoogleAddressAutocomplete from '@/components/GoogleAddressAutocomplete'
import googleMapsApi from '@/mixins/googleMapsApi'

export default {
  name: 'OnboardingProfileSetup',
  components: { UploadImage },
  mixins: [validationMixin],
  props: {
    user: { type: Object, required: true },
    submitting: { type: Boolean, default: () => false }
  },
  data() {
    return {
      rules,
      form: {
        uploads: {
          national_ID: null,
          typhoid_vaccine_card: null
        }
      },

      files: {
        national_ID: null,
        typhoid_vaccine_card: null
      }
    }
  },
  created() {
    // Event tracking
    const { once } = this.lodash
    const { logEvent } = this.$amplitude

    this.typhoidCardUploaded = once(() => {
      logEvent('Seller Onboarding: Typhoid Card Uploaded')
    })
    this.nationalIdUploaded = once(() => {
      logEvent('Seller Onboarding: ID Uploaded')
    })

    // Prefill form
    const { uploads } = this.user
    const { national_ID, typhoid_vaccine_card } = uploads || {}
    this.form = {
      uploads: { national_ID, typhoid_vaccine_card }
    }
  },
  methods: {
    onTVCFileChange({ src, file }) {
      this.files.typhoid_vaccine_card = file
      this.form.uploads.typhoid_vaccine_card = src
      this.typhoidCardUploaded()
    },

    onNIDFileChange({ src, file }) {
      this.files.national_ID = file
      this.form.uploads.national_ID = src
      this.nationalIdUploaded()
    },

    submit() {
      if (this.submitting || this.$v.$invalid) return

      const data = { uploads: { ...this.files } }
      this.$emit('submit', data)
    }
  },
  validations: {
    form: {
      uploads: {
        national_ID: { required },
        typhoid_vaccine_card: { required }
      }
    }
  }
}
</script>

<template>
  <div class="view-grid">
    <div>
      <!-- Onboarding Profile // Verification -->
      <form @submit.prevent="submit()">
        <!-- Title -->
        <div class="display-1 font-weight-bold accent--text">
          Upload your IDs
        </div>

        <!-- Typhoid vaccination card -->
        <div class="mt-7">
          <div class="font-weight-bold">
            Typhoid vaccination card
          </div>
          <div class="body-2 mb-5">
            You are required by law to have immunisation against typhoid fever
            to sell your food.
          </div>

          <v-layout>
            <v-flex xs2 mr-3>
              <UploadImage
                :default-src="form.uploads.typhoid_vaccine_card"
                @input="onTVCFileChange"
              />
            </v-flex>

            <v-flex xs6 class="d-flex align-center">
              <div class="secondary--text caption">
                Make sure all details on the card are clearly visible
              </div>
            </v-flex>
          </v-layout>
        </div>

        <!-- National ID -->
        <div class="my-7">
          <div class="font-weight-bold">
            National ID
          </div>
          <div class="body-2 mb-5">
            MyKad, driving license, or travel passport
          </div>

          <v-layout>
            <v-flex xs2 mr-3>
              <UploadImage
                :default-src="form.uploads.national_ID"
                @input="onNIDFileChange"
              />
            </v-flex>

            <v-flex xs6 class="d-flex align-center">
              <div class="secondary--text caption">
                Make sure all details on the card are clearly visible
              </div>
            </v-flex>
          </v-layout>
        </div>

        <!-- Action Buttons -->
        <div class="my-5">
          <v-btn
            :loading="submitting"
            :disabled="$v.$invalid"
            type="submit"
            rounded
            depressed
            color="primary"
          >
            Continue
          </v-btn>
        </div>
      </form>
    </div>
  </div>
</template>
